import { fetchData } from "./fetchData";

//users assigned to jobs

export const getUsersAssignedToJobAPI = async (JobID) => {
    const route = `/admin/jobs/${JobID}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

export const getJobsAssignedToUserAPI = async (UserID) => {
    const route = `/admin/jobs/user/${UserID}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

export const assignJobToUserAPI = async (JobID, UserID) => {
    const route = `/admin/jobs/${JobID}`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({UserID})
    }

    let response = await fetchData(route, options);

    return response;
}

export const unassignJobFromUserAPI = async (JobID, UserID) => {
    const route = `/admin/jobs/${JobID}`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({UserID})
    }

    let response = await fetchData(route, options);

    return response;
}

//job links

export const getAllJobLinksAPI = async () => {
    const route = `/admin/jobs/links`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

export const createJobLinkAPI = async (JobID) => {
    const route = `/admin/jobs/links/${JobID}`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
    }

    let response = await fetchData(route, options);

    return response;
}

export const updateJobLinkIsActiveAPI = async (JobID, LinkID, IsActive) => {
    const route = `/admin/jobs/links/${JobID}`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({IsActive, LinkID})

    }

    let response = await fetchData(route, options);

    return response;
}